
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import FormHelpText from "../components/FormHelpText";
import { UseFormReturn } from "react-hook-form";
import { ListingFormValues } from "../../filters/FilterSchema";

interface MediaLinksFieldsProps {
  form: UseFormReturn<ListingFormValues>;
}

const MediaLinksFields = ({ form }: MediaLinksFieldsProps) => {
  return (
    <>
      {/* Video URL */}
      <div className="border rounded-md p-4">
        <FormField
          control={form.control}
          name="videoUrl"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-base font-medium">Video URL (Optional)</FormLabel>
              <FormControl>
                <Input
                  placeholder="e.g., https://youtube.com/watch?v=abcdef"
                  {...field}
                />
              </FormControl>
              <FormHelpText>
                Add a YouTube or Vimeo link to a video tour of your property.
              </FormHelpText>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      {/* Additional Media Links */}
      <div className="border rounded-md p-4">
        <FormField
          control={form.control}
          name="extraMediaLinks"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-base font-medium">Additional Media Links (Optional)</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Enter any additional links to virtual tours, floor plans, or other media."
                  className="min-h-[100px]"
                  {...field}
                />
              </FormControl>
              <FormHelpText>
                Add links to virtual tours, 3D models, floor plans, or other media. Separate multiple links with a new line.
              </FormHelpText>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </>
  );
};

export default MediaLinksFields;
